module.exports = __webpack_public_path__ + "img/icon-burger.cad9a50d.svg";